export default __webpack_public_path__ + "static/media/img-press-release-coin-listed.9f13f180.jpg";